export const userMenus = [
  { text: "Home", navigateTo: "/" },
  { text: "User Register", navigateTo: "/user-register" },
  { text: "New Teacher Training", navigateTo: "/pedagogy" },
  { text: "Common Monthly Quiz", navigateTo: "/commonmonthlyquiz" },
  { text: "New Student Activity", navigateTo: "/flnactivity" },
  { text: "Intro Quiz", navigateTo: "/introquiz" },
  { text: "Feedback", navigateTo: "/feedback" },
  { text: "Erase Userdata", navigateTo: "/erase-userdata" },
  { text: "FAQ", navigateTo: "/faq" },
  { text: "Maintainance", navigateTo: "/maintainance" },
  { text: "Dashboard Slider", navigateTo: "/dashboard_slider" },
  { text: "Amazon Pay Voucher", navigateTo: "/amazonpay" },
  { text: "Amazon Voucher Status", navigateTo: "/amazonpaystatus" },
  { text: "Gamified Module", navigateTo: "/gamified-module" },
  { text: "E.C Allocation", navigateTo: "/userallocation" },
  { text: "Top Parents", navigateTo: "/topparent" },

  // { text: "Home", navigateTo: "/home" },
  // { text: "App Versions", navigateTo: "/versions" },
  // { text: "Users", navigateTo: "/users" },
  // { text: "Passcode Manager", navigateTo: "/passcodemanager" },
  // { text: "Passcode Requests", navigateTo: "/passcode-requests" },
  // { text: "Audio Labeling", navigateTo: "/audiolabeling" },
  // { text: "User Swap", navigateTo: "/userswap" },
  // { text: "thinkzone servers", navigateTo: "/thinkzoneservers" },
  // { text: "Student Assessment", navigateTo: "/studentassessment" },
  // { text: "Blocks and Districts", navigateTo: "/blockspage" },
  // { text: "Prakashak DistrictWise", navigateTo: "/prakashak-district" },
];

export const adminMenus = [
  { text: "Home", navigateTo: "/" },
  { text: "User Register", navigateTo: "/user-register" },
  { text: "Teacher Training", navigateTo: "/pedagogy" },
  { text: "Gamified Module", navigateTo: "/gamified-module" },
  { text: "Common Monthly Quiz", navigateTo: "/commonmonthlyquiz" },
  { text: "Student Activity", navigateTo: "/flnactivity" },
  { text: "Teachers Data Upload", navigateTo: "/teachersDataUplaod" },
  { text: "Intro Quiz", navigateTo: "/introquiz" },
  { text: "Amazon Pay Voucher", navigateTo: "/amazonpay" },
  { text: "Amazon Voucher Status", navigateTo: "/amazonpaystatus" },
  { text: "FAQ", navigateTo: "/faq" },
  { text: "Dashboard Slider", navigateTo: "/dashboard_slider" },
  { text: "Feedback", navigateTo: "/feedback" },
  { text: "Maintainance", navigateTo: "/maintainance" },
  { text: "Erase Userdata", navigateTo: "/erase-userdata" },
  { text: "Upload Books", navigateTo: "/uploadBooks" },
  { text: "PRAKASAK Data Upload", navigateTo: "/prakasak" },

  // { text: "App Session", navigateTo: "/app-session" },
  // { text: "PRAKASAK Data Upload", navigateTo: "/prakasak" },
  // { text: "Remote Instruction Upload", navigateTo: "/prakasakData" },
  // { text: "E.C Allocation", navigateTo: "/userallocation" },
  // { text: "DistrictWise Data Upload", navigateTo: "/prakashak-district" },
  // {
  //   text: "Prakashak Static Data Upload",
  //   navigateTo: "/prakashak-static-data",
  // },
  // { text: "E.C Password Managers", navigateTo: "/ece-password-manager" },
  // {
  //   text: "Performance Certificate Upload",
  //   navigateTo: "/PerformanceCertificate",
  // },
  // { text: "Top Parents", navigateTo: "/topparent" },
  // { text: "EC Student Edit Requests", navigateTo: "/ec-student-edit" },
  // { text: "Home", navigateTo: "/home" },
  // { text: "Users", navigateTo: "/users" },
  // { text: "User Logs", navigateTo: "/userLogs" },
  // { text: "Passcode Manager", navigateTo: "/passcodemanager" },
  // { text: "Passcode Requests", navigateTo: "/passcode-requests" },
  // { text: "Audio Labeling", navigateTo: "/audiolabeling" },
  // { text: "User Swap", navigateTo: "/userswap" },
  // { text: "Server", navigateTo: "/server" },
  // { text: "App Versions", navigateTo: "/versions" },
  // { text: "thinkzone servers", navigateTo: "/thinkzoneservers" },
  // { text: "Student Assessment", navigateTo: "/studentassessment" },
  // { text: "Training Extra Resources", navigateTo: "/trainingextraresources" },
  // { text: "Meta", navigateTo: "/templates" },
  // { text: "Matching App ", navigateTo: "/match/:userId" },
  // { text: "Blocks and Districts", navigateTo: "/blockspage" },
  // { text: "TokenCode", navigateTo: "/tokencode" },
];

export const prakashakMenus = [
  { text: "PRAKASAK Data Upload", navigateTo: "/prakasak" },
  { text: "Remote Instruction Upload", navigateTo: "/prakasakData" },
  { text: "E.C Allocation", navigateTo: "/userallocation" },
  { text: "DistrictWise Data Upload", navigateTo: "/prakashak-district" },
  {
    text: "Prakashak Static Data Upload",
    navigateTo: "/prakashak-static-data",
  },
  { text: "E.C Password Managers", navigateTo: "/ece-password-manager" },
  {
    text: "Performance Certificate Upload",
    navigateTo: "/PerformanceCertificate",
  },
  { text: "Top Parents", navigateTo: "/topparent" },
];

export const passcodeMenus = [
  { text: "Passcode Requests", navigateTo: "/passcode-requests" },
  { text: "Passcode Manager", navigateTo: "/passcodemanager" },
];
